(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["janine-shop-categories"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('janine-shop-categories')) {
    customElements.define('janine-shop-categories', class extends HTMLElement {
      connectedCallback() {
        this.syncLinks = this.syncLinks.bind(this);
        window.addEventListener('janine:filters-updated', this.syncLinks);
        window.addEventListener('popstate', this.syncLinks);
        this.syncLinks();
      }

      disconnectedCallback() {
        window.removeEventListener('janine:filters-updated', this.syncLinks);
        window.removeEventListener('popstate', this.syncLinks);
      }

      syncLinks() {
        const current = new URL(window.location.href);
        const allowed = ['sort_by', 'filter.v.availability', 'filter.v.price.gte', 'filter.v.price.lte'];
        this.querySelectorAll('[data-shop-category]').forEach((link) => {
          const destination = new URL(link.dataset.shopCategory, window.location.origin);
          allowed.forEach((key) => current.searchParams.getAll(key).forEach((value) => destination.searchParams.append(key, value)));
          link.href = `${destination.pathname}${destination.search}`;
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
